import { render, staticRenderFns } from "./QuotationCategories.vue?vue&type=template&id=74d57062"
import script from "./QuotationCategories.vue?vue&type=script&lang=js"
export * from "./QuotationCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports